export const permissionFilters = {
    config: {
        rowsPerPage: true,
        paginationPage: true,
        search: true
    }
}
